import React, { useState, useEffect } from "react";
import "../../styles/batteryCard.css";
import BatteryCard from "./BatteryCard";
import styled from "styled-components";

// import BatteryCompany from "./BatteryCompany";

export default function BatteryPage(data) {
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  var [triger, setTriger] = useState(1);

  useEffect(() => {
    const url = data.history.location.pathname;
    fetch(`https://v3-backend-battery.herokuapp.com${url}/?skip=${count}`)
      .then((res) => res.json())
      .then((res) => {
        setItems(items.concat(res));
        // eslint-disable-next-line react-hooks/exhaustive-deps
        setTriger((triger = 1));
      });
  }, [count]);

  function increaseCount() {
    setTriger((triger = 0));
    setCount(count + 8);
  }

  const _BatteryCards = items.map((item) => {
    return <BatteryCard item={item} />;
  });
  if (items.length === 0) {
    return (
      <div>
        {/* <BatteryCompany /> */}
        <div className="productContainer">{_BatteryCards}</div>
        <div className="loading">
          <SpinnerFun />
        </div>
      </div>
    );
  } else {
    return (
      <div>
        {/* <BatteryCompany /> */}
        <div className="productContainer">{_BatteryCards}</div>
        <div className="loading">
          {triger === 1 ? (
            <button className="btn btn-primary" onClick={() => increaseCount()}>
              Load More
            </button>
          ) : (
            <SpinnerFun></SpinnerFun>
          )}
        </div>
      </div>
    );
  }
}

const Spinner = styled.div`
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

function SpinnerFun() {
  return <Spinner />;
}
